import { TextField } from "@mui/material";
import React, { useMemo, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState, setTotalValues } from "./defineSlice";
import './Define.css'
import { formatNumber, removeComma, isWeekColumnEditable, rowDepletionModelKey, findGridRowByCustomerSku, commitGridDataUpdate } from "./defineUtils";
import debounce from 'lodash/debounce';
import {
	QUOTA_CELL_DEBOUNCE_MS,
	useQuotaCellInputSync,
} from "./useQuotaCellInput";

export default function TableCellWeek1(params) {
   const dispatch = useDispatch();
   const define = useSelector((state) => state.define);
   const { gridData, gridDataFiltered, selectedDepletionPeriodType } = define;
   const gridDataRef = useRef(gridData);
   const gridDataFilteredRef = useRef(gridDataFiltered);
   gridDataRef.current = gridData;
   gridDataFilteredRef.current = gridDataFiltered;
   const rowDm = rowDepletionModelKey(params.row);
   const cellInput = useQuotaCellInputSync(params.row.weekly1);
   const { setDraft, displayValue, onFocus, onBlur } = cellInput;
   const customerID = params.row.customerID;
   const customerGroupID = params.row.customerGroupID;
   const productGroupID = params.row.productGroupID;
   const skuid = params.row.skuid;

   function updateGrid(hasError, w) {
      let updatedItem = null;
      const filtered = gridDataFilteredRef.current;
      const fullGrid = gridDataRef.current;
      const updated = filtered.map((item, index) => {
         const flag =
            item.customerID === customerID &&
            item.customerGroupID === customerGroupID &&
            item.productGroupID === productGroupID &&
            item.skuid === skuid;
         if (flag === true) {
            updatedItem = {
               ...item,
               hasError,
               weekly1: !w ? 0 : w,
            };
            return updatedItem;
         }
         return item;
      });

      const updatedGrid = [];
      for (let i = 0; i < fullGrid.length; ++i) {
         const item = fullGrid[i];
         if(item.id === updatedItem.id) {
            updatedGrid.push(updatedItem);
         }
         else {
            updatedGrid.push(item);
         }
      }
      commitGridDataUpdate(dispatch, setState, {
         gridData: updatedGrid,
         gridDataFiltered: updated,
         updatedRow: updatedItem,
         backupFields: ["weekly1"],
      });
   }

   // function updateWeek1(event) {
   //    let w1 = removeComma(event.target.value);
   //    w1 = Number(w1);
   //    let w2 = Number(params.row.weekly2);
   //    let hasError = false;
   //    setWeek1(w1);

   //    if (!w1 && w1 !== 0) {
   //       dispatch(setState("isError", true));
   //       dispatch(setState("isError_Info", "Only numbers are allowed."));
   //       return;
   //    }
   //    if (selectedDepletion.key === "biweekly") {
   //       if (w1 > w2) {
   //          hasError = true;
   //       }
   //    }
   //    if (w1 > w2) {
   //       hasError = true;
   //    }
   //    dispatch(setState("gridDataChanged", true));
   //    updateGrid(hasError, w1);
   //    dispatch(setTotalValues());
   // }

   const debouncedUpdate = useMemo(
      () =>
         debounce((hasError, w1) => {
            dispatch(setState("gridDataChanged", true));
            updateGrid(hasError, w1);
            dispatch(setTotalValues());
         }, QUOTA_CELL_DEBOUNCE_MS),
      [
         params.row?.customerID,
         params.row?.customerGroupID,
         params.row?.productGroupID,
         params.row?.skuid,
         params.row?.depletionModel,
         dispatch,
      ]
   );

   useEffect(() => {
      return () => debouncedUpdate.cancel();
   }, [debouncedUpdate]);

   function updateWeek1(event) {
      let raw = removeComma(event.target.value);
      setDraft(raw);
      let w1 = Number(raw);
      const live =
         findGridRowByCustomerSku(gridDataFilteredRef.current, params.row) ??
         findGridRowByCustomerSku(gridDataRef.current, params.row) ??
         params.row;
      const dmLive = rowDepletionModelKey(live);
      let w2 = Number(live.weekly2);
      const quota = Number(live.quota);
      let hasError = false;

      if (!w1 && w1 !== 0) {
         dispatch(setState("isError", true));
         dispatch(setState("isError_Info", "Only numbers are allowed."));
         return;
      }
      if (dmLive === "none") {
         if (w1 !== quota) {
            hasError = true;
         }
      } else if (w1 > w2) {
         hasError = true;
      }
      debouncedUpdate(hasError,w1);

   }

   function handleValidity(w1, w2){
      const quota = Number(params.row.quota);
      if (rowDm === "none") {
         if (Number(w1) !== quota) {
            dispatch(setState("isError", true));
            dispatch(setState("isError_Info", "Must equal quota"));
         }
      } else if (Number(w1) > Number(w2)) {
         dispatch(setState("isError", true));
         dispatch(setState("isError_Info", "Must be less or equal to Week2"));
      }
   }

   return (
      <TextField
         variant="standard"
         disabled={
            !isWeekColumnEditable(
               1,
               params.row,
               selectedDepletionPeriodType
            )
         }
         value={displayValue}
         className={
            rowDm === "none"
               ? Number(params.row.weekly1) !== Number(params.row.quota)
                  ? "red-row"
                  : ""
               : Number(params.row.weekly1) > Number(params.row.weekly2)
                  ? "red-row"
                  : ""
         }
         onChange={updateWeek1}
         onFocus={onFocus}
         onBlur={() => {
            debouncedUpdate.flush();
            onBlur();
            handleValidity(params.row.weekly1, params.row.weekly2);
         }}
         sx={{ width: 100 }}
      />
   );
}
